"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUserPermissions = exports.validateUserPermissions = void 0;
const zod_1 = require("zod");
const mxu_bootcamp_types_1 = require("./mxu_bootcamp_types");
const subscription_plan_types_1 = require("./subscription_plan_types");
const subscription_types_1 = require("./subscription_types");
const user_subscriptions_types_1 = require("./user_subscriptions_types");
const UserPermissionsSchema = zod_1.z.object({
    activeWeeklyCoachingSubscriptions: user_subscriptions_types_1.UserFacingWeeklyCoachingSubscriptionSchema.array(),
    canCreateFlashcards: zod_1.z.boolean(),
    canReviewFlashcards: zod_1.z.boolean(),
    canSearchExplore: zod_1.z.boolean(),
    enrolledMxuBootcamps: mxu_bootcamp_types_1.UserFacingBootcampSchema.array(),
    hasOverduePayments: zod_1.z.boolean().optional(),
    isBacker: zod_1.z.boolean(),
    subscriptionCancelReason: subscription_types_1.SubscriptionCancelReasonSchema.optional(),
    subscriptionExpirationDate: zod_1.z.string().optional(),
    subscriptionPlanId: zod_1.z.string().optional(),
    subscriptionProvider: subscription_plan_types_1.SubscriptionProviderSchema.optional(),
    subscriptionStatus: subscription_types_1.SubscriptionStatusSchema.optional(),
    trialDaysAdded: zod_1.z.number().optional(),
    trialExpirationDate: zod_1.z.string().optional(),
});
const validateUserPermissions = (x) => UserPermissionsSchema.safeParse(x);
exports.validateUserPermissions = validateUserPermissions;
const isUserPermissions = (x) => exports.validateUserPermissions(x).success;
exports.isUserPermissions = isUserPermissions;
//# sourceMappingURL=permissions.js.map